import React, { Component } from 'react';
import MetaTags from 'react-meta-tags';
import 'bootstrap/dist/css/bootstrap.css';
import '../home/Home.css';

class CompanyLanding extends Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <div className="for-companies-container">
        <MetaTags>
          <title>Companies</title>
          <meta
            name="description"
            content="Connect with and source the hottest influencers on leading platforms like YouTube. Our platform allows direct messaging with influencers and provides the info that counts via analytics which provide details like follower counts and more."
          />
          <meta
            name="keywords"
            content="Influencer Marketing, Influencer Platform, Influencer Marketplace,YouTube Influencers, Instagram Influencers, Twitch Influencers,YouTube,Instagram,Twitch,Influencer,Influencers,Marketplace,Platform"
          />
        </MetaTags>
        <div className="nav-bar-holder">
          <nav className="navbar navbar-expand-sm navbar-light" />
        </div>
        <div className="text-header-container">
          <div className="container">
            <div className="header-holder">
              <h2 className="page-text-heading-brand">Brands</h2>
            </div>
            <p className="padded-top-paragraph">
              Hypepilot is an open, free-to-register platform that allows
              companies to directly find and source the influencers right for
              them. Create campaigns to promote products and receive offers from
              the kinds of influencers you want. Conveniently manage your
              campaigns all in one place
            </p>
          </div>
        </div>
        <img className="side-page-img" src="/images/brand-page-pic.png" />
        <div
          id="features"
          className="influencer-wrapper container primary-font-color"
        >
          <div className="row">
            <div className="col-sm-6">
              <img
                className="influencer-icon-7"
                src="/images/format-list-checks.png"
              />
              <h3 className="influencer-heading">Track your deals</h3>
              <p className="influencer-para">
                Reach out to influencers, review proposals, make revisions, and
                manage deadlines all in one place.
              </p>
            </div>
            <div className="col-sm-6">
              <img className="influencer-icon-2" src="/images/chart-line.png" />
              <h3 className="influencer-heading">Influencer analytics</h3>
              <p className="influencer-para">
                Get the info that counts when choosing influencers for your
                campaigns. Get follower counts, audience countries and more.
              </p>
            </div>
          </div>
          <div className="row padded-top-row">
            <div className="col-sm-6">
              <img className="influencer-icon-5" src="/images/forum.png" />
              <h3 className="influencer-heading">Live chat with influencers</h3>
              <p className="influencer-para">
                Emails are old, slow, and boring. Hypepilot allows for real-time
                communication with the people you’re working with.
              </p>
            </div>
            <div className="col-sm-6">
              <img className="influencer-icon-5" src="/images/view-list.png" />
              <h3 className="influencer-heading">Campaign management</h3>
              <p className="influencer-para">
                Manage all of your campaigns at one place. Receive offers from
                influencers you are interested in.
              </p>
            </div>
          </div>
        </div>
        <div className="nav-bar-holder">
          <nav className="navbar navbar-expand-sm navbar-light" />
        </div>
      </div>
    );
  }
}

export default CompanyLanding;



// WEBPACK FOOTER //
// ./src/components/home/ForCompanies.js